import React from 'react';
import MultimediaModalContainer from '@components/DeviceContainers/Multimedia/MultimediaModalContainer';
import TemperatureModalContainer from '@components/DeviceContainers/Temprature/TempModalComponents/TemperatureModalContainer';

function ModalChildrenSelector(type, setIsModalOpen, multimedia, conditioner, func) {
  switch (type) {
    case 'multimedia':
      return (
        <MultimediaModalContainer setIsModalOpen={(val) => setIsModalOpen(val)} multimedia={multimedia} func={func} />
      );
    case 'temperature':
      return (
        <TemperatureModalContainer setIsModalOpen={(val) => setIsModalOpen(val)} conditioner={conditioner} changeValue={func} />
      );
    default:
      return (null);
  }
} export default ModalChildrenSelector;
